export const visit = (vm, at) => {
vm(require("property-management-iframe/lang/en.lyaml"));
vm(require("commerce-contract-lib/lang/en.lyaml"));
vm(require("commerce-tools-ui-lib/lang/en.lyaml"));
vm(require("in-meeting-experience-ui-components/lang/en.lyaml"));
vm(require("calling-integration-timeline-event/lang/en.lyaml"));
vm(require("commerce-billing-lib/lang/en.lyaml"));
vm(require("crm-display-components/lang/en.lyaml"));
vm(require("crm-meetings-components-lib/lang/en.lyaml"));
vm(require("hubspot-prosemirror/lang/en.lyaml"));
vm(require("reporting-enablement/lang/en.lyaml"));
vm(require("playlists-lib/lang/en.lyaml"));
vm(require("commerce-subscription-lib/lang/en.lyaml"));
vm(require("crm-cards-sdk/lang/en.lyaml"));
vm(require("crm-cards/lang/en.lyaml"));
vm(require("crm-command-handler/lang/en.lyaml"));
vm(require("crm-object-preview/lang/en.lyaml"));
vm(require("integration-settings-components/lang/en.lyaml"));
vm(require("ui-business-units-lib/lang/en.lyaml"));
vm(require("calling-lifecycle-internal/lang/en.lyaml"));
vm(require("SharedI18nStrings/lang/languageNames/en.lyaml"));
vm(require("reporting-data/lang/en.lyaml"));
vm(require("customer-data-property-utils/lang/en.lyaml"));
vm(require("ui-addon-form-validation/lang/en.lyaml"));
vm(require("deal-splits-sidebar/lang/en.lyaml"));
vm(require("reporting-visualizations/lang/en.lyaml"));
vm(require("draft-plugins/lang/en.lyaml"));
vm(require("ExportDialog/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/en.lyaml"));
vm(require("InboxConnectUtils/lang/en.lyaml"));
vm(require("SalesContentIndexUI/lang/en.lyaml"));
vm(require("email-confirm-ui/lang/en.lyaml"));
vm(require("timezone-utils/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
vm(require("ui-addon-avatars/lang/en.lyaml"));
vm(require("products-ui-components/lang/en.lyaml"));
vm(require("ui-addon-i18n/lang/en.lyaml"));
vm(require("ui-addon-scriptloader/lang/en.lyaml"));
vm(require("ui-addon-opt/lang/en.lyaml"));
vm(require("ui-addon-teams/lang/en.lyaml"));
vm(require("SharedI18nStrings/lang/countryCodes/en.lyaml"));
vm(require("BizOpsCrmUIComponents/lang/en.lyaml"));
vm(require("partner-shared-view-ui/lang/en.lyaml"));
vm(require("MeetingsLib/lang/en.lyaml"));
vm(require("conversations-message-history/lang/en.lyaml"));
vm(require("conversations-inbox-message-history/lang/en.lyaml"));
vm(require("conversations-thread-view-crm-events/lang/en.lyaml"));
vm(require("ui-gdpr-components/lang/en.lyaml"));
vm(require("playbooks-modal/lang/en.lyaml"));
vm(require("composer-plugins/lang/en.lyaml"));
vm(require("rich-text-lib/lang/en.lyaml"));
vm(require("native-integrations-shared-strings/lang/AccountingExtension/en.lyaml"));
vm(require("ui-shepherd-react/lang/en.lyaml"));
vm(require("property-translator/lang/en.lyaml"));
vm(require("customer-data-communicator/lang/en.lyaml"));
vm(require("crm_components/lang/en.lyaml"));
vm(require("customer-data-filters/lang/en.lyaml"));
vm(require("customer-data-objects-ui-components/lang/en.lyaml"));
vm(require("customer-data-properties/lang/en.lyaml"));
vm(require("customer-data-email/lang/en.lyaml"));
vm(require("customer-data-ui-utilities/lang/en.lyaml"));
vm(require("crm_ui/lang/crm-internal-legacy/en.lyaml"));
vm(require("customer-data-rte/lang/en.lyaml"));
vm(require("crm_universal/lang/en.lyaml"));
vm(require("crm_schema/lang/en.lyaml"));
vm(require("customer-data-objects/lang/en.lyaml"));
vm(require("customer-data-reference-ui-components/lang/en.lyaml"));
vm(require("sales-clients-common/lang/en.lyaml"));
vm(require("react-colorpicker/lang/en.lyaml"));
vm(require("reporting-action-components/lang/en.lyaml"));
vm(require("reporting-ui-components/lang/en.lyaml"));
vm(require("sanitize-text/lang/en.lyaml"));
vm(require("file-manager-components/lang/en.lyaml"));
vm(require("FileManagerLib/lang/en.lyaml"));
vm(require("./communicator/en.lyaml"));
vm(require("transcript-sidebar/lang/en.lyaml"));
vm(require("universal-associations-select/lang/en.lyaml"));
vm(require("crm-timeline/lang/en.lyaml"));
vm(require("deal-registration-ui/lang/en.lyaml"));
vm(require("call-widget-addon/lang/en.lyaml"));
vm(require("calling-internal-common/lang/en.lyaml"));
vm(require("ui-asset-management-lib/lang/en.lyaml"));
vm(require("calling-ui-library/lang/en.lyaml"));
vm(require("crm_data/lang/en.lyaml"));
vm(require("calling-ui-library/lang/timeline-call-metadata/en.lyaml"));
vm(require("segment-references-panel-lib/lang/en.lyaml"));
vm(require("chatspot-widget-iframe/lang/en.lyaml"));
vm(require("ui-business-units-lib/lang/en.lyaml"));
vm(require("subscriptions-components/lang/en.lyaml"));
vm(require("card-preview-highlight-lib/lang/en.lyaml"));
vm(require("ui-suspension-banners-lib/lang/en.lyaml"));
vm(require("calling-orchestration-shared-library/lang/en.lyaml"));
vm(require("crm-activity-creator-widgets/lang/en.lyaml"));
vm(require("crm-activity-creator-interaction-window/lang/en.lyaml"));
vm(require("quotes-ui-lib/lang/en.lyaml"));
vm(require("settings-ui-nav/lang/en.lyaml"));
vm(require("object-builder-ui-client/lang/en.lyaml"));
vm(require("reference-resolvers-lite/lang/en.lyaml"));
vm(require("flywheel-feedback-panel-components/lang/en.lyaml"));
vm(require("crm_ui/lang/en.lyaml"));
vm(require("call-timeline-event/lang/en.lyaml"));
vm(require("lead-tracking-lib/lang/en.lyaml"));
vm(require("ui-extensions-remote-renderer/lang/en.lyaml"));
vm(require("crm-extension/lang/en.lyaml"));
vm(require("crm-source-interpretation-lib/lang/en.lyaml"));
vm(require("property-history-panel/lang/en.lyaml"));
vm(require("crm-activity-creator-interactions-legacy/lang/en.lyaml"));
vm(require("sequences-crm-events-lib/lang/en.lyaml"));
vm(require("ui-product-approvals/lang/en.lyaml"));
vm(require("crm-pipeline-approvals-lib/lang/en.lyaml"));
vm(require("card-properties-lib/lang/en.lyaml"));
vm(require("card-associated-objects-lib/lang/en.lyaml"));
vm(require("card-object-highlight-lib/lang/en.lyaml"));
vm(require("foundations-components/lang/en.lyaml"));
vm(require("sequences-crm-lib/lang/en.lyaml"));
vm(require("./catchUpTab/en.lyaml"));
at({ "en": { "crm-records-ui": { "tabs": { "recordEditorLink": "Customize record" }, "collapsibleSidebar": { "hide": "Hide sidebar", "show": "Show sidebar", "ariaHide": "Hide right sidebar", "ariaShow": "Open right sidebar" }, "enrollInWorkflowModal": { "confirm": "Enroll", "cancel": "Cancel" } } } });
};